const missatgeErrorGeneric = "S'ha produït algun error";

const promiseMiddleware = () => {
  return next => action => {
    const { promise, type, ...rest } = action;
    if (!promise) {
      return next(action);
    }

    const enCurs = `${type}_EN_CURS`;
    const success = `${type}_SUCCESS`;
    const failure = `${type}_ERROR`;

    next({ ...rest, type: enCurs });
    return promise.then(
      result => next({ ...rest, payload: result, type: success }),
      error =>
        next({ ...rest, error: error || missatgeErrorGeneric, type: failure })
    );
  };
};

export default promiseMiddleware;
